export default __webpack_public_path__ + "static/media/online-pk-5-banner-mobile.564889f1.png";